import { klwAxios, mock } from "helpers/api";

export const MOCK_HERBEREKEN = {
  grondfosfaatToestandenModel: {
    fosfaattoestandOppervlakten: [
      {
        fosfaattoestandCategorieId: 8,
        graslandOppervlakte: 44.34,
        natuurgraslandOppervlakte: 0.19,
        snijmaisOppervlakte: 7.71,
        akkerbouwOppervlakte: 0,
        omschrijving: "Fosfaat hoog",
      },
      {
        fosfaattoestandCategorieId: 7,
        graslandOppervlakte: 0,
        natuurgraslandOppervlakte: 0,
        snijmaisOppervlakte: 0,
        akkerbouwOppervlakte: 0,
        omschrijving: "Fosfaat ruim",
      },
      {
        fosfaattoestandCategorieId: 6,
        graslandOppervlakte: 0,
        natuurgraslandOppervlakte: 0,
        snijmaisOppervlakte: 0,
        akkerbouwOppervlakte: 0,
        omschrijving: "Fosfaat neutraal",
      },
      {
        fosfaattoestandCategorieId: 5,
        graslandOppervlakte: 0,
        natuurgraslandOppervlakte: 0,
        snijmaisOppervlakte: 0,
        akkerbouwOppervlakte: 0,
        omschrijving: "Fosfaat laag",
      },
      {
        fosfaattoestandCategorieId: 4,
        graslandOppervlakte: 0,
        natuurgraslandOppervlakte: 0,
        snijmaisOppervlakte: 0,
        akkerbouwOppervlakte: 0,
        omschrijving: "Fosfaat arm",
      },
    ],
  },
  kenmerkenMineralenGrondToestandenModel: {
    kenmerkenMineralenGrondToestanden: [
      {
        kenmerkenMineralenGrondBodemCategorie: 8,
        natuurWaarde: 0,
        grasConWaarde: 15.9,
        grasWisWaarde: 15.9,
        bouwConWaarde: 8.6,
        bouwWisWaarde: 8.6,
        omschrijving: "C/N-ratio Monster",
      },
      {
        kenmerkenMineralenGrondBodemCategorie: 7,
        natuurWaarde: 0,
        grasConWaarde: 9.91,
        grasWisWaarde: 9.91,
        bouwConWaarde: 3.0,
        bouwWisWaarde: 3.0,
        omschrijving: "Klei (Lutum) Monster",
      },
      {
        kenmerkenMineralenGrondBodemCategorie: 6,
        natuurWaarde: 0,
        grasConWaarde: 7.63,
        grasWisWaarde: 7.63,
        bouwConWaarde: 6.2,
        bouwWisWaarde: 6.2,
        omschrijving: "Koolstof (SOC) Monster",
      },
      {
        kenmerkenMineralenGrondBodemCategorie: 5,
        natuurWaarde: 0,
        grasConWaarde: 14.38,
        grasWisWaarde: 14.38,
        bouwConWaarde: 16.4,
        bouwWisWaarde: 16.4,
        omschrijving: "Organische stof Monster",
      },
      {
        kenmerkenMineralenGrondBodemCategorie: 4,
        natuurWaarde: 10,
        grasConWaarde: 10.33,
        grasWisWaarde: 10.33,
        bouwConWaarde: 10,
        bouwWisWaarde: 10,
        omschrijving: "C/N-ratio Regio",
      },
      {
        kenmerkenMineralenGrondBodemCategorie: 3,
        natuurWaarde: 16.44,
        grasConWaarde: 16.14,
        grasWisWaarde: 16.14,
        bouwConWaarde: 16.73,
        bouwWisWaarde: 16.73,
        omschrijving: "Klei (Lutum) Regio",
      },
      {
        kenmerkenMineralenGrondBodemCategorie: 2,
        natuurWaarde: 2.27,
        grasConWaarde: 2.25,
        grasWisWaarde: 2.25,
        bouwConWaarde: 1.76,
        bouwWisWaarde: 1.76,
        omschrijving: "Koolstof (SOC) Regio",
      },
      {
        kenmerkenMineralenGrondBodemCategorie: 1,
        natuurWaarde: 4.2,
        grasConWaarde: 4.16,
        grasWisWaarde: 4.16,
        bouwConWaarde: 3.26,
        bouwWisWaarde: 3.26,
        omschrijving: "Organische stof Regio",
      },
    ],
  },
  grondsoortenModel: {
    verdelingGrondsoorten: [
      {
        grondsoortcategorieId: 1,
        omschrijving: "Aandeel veen",
        grasland: 0,
        natuurgrasland: 0,
        akkerbouw: 0,
        snijmaisland: 0,
        graslandPercentage: 0,
        natuurgraslandPercentage: 0,
        akkerbouwPercentage: 0,
        snijmaislandPercentage: 0,
      },
      {
        grondsoortcategorieId: 2,
        omschrijving: "Aandeel klei",
        grasland: 41.88,
        natuurgrasland: 0.19,
        akkerbouw: 0,
        snijmaisland: 7.71,
        graslandPercentage: 94,
        natuurgraslandPercentage: 100,
        akkerbouwPercentage: 0,
        snijmaislandPercentage: 100,
      },
      {
        grondsoortcategorieId: 3,
        omschrijving: "Aandeel zand, nat (I-V)",
        grasland: 1.57,
        natuurgrasland: 0,
        akkerbouw: 0,
        snijmaisland: 0,
        graslandPercentage: 4,
        natuurgraslandPercentage: 0,
        akkerbouwPercentage: 0,
        snijmaislandPercentage: 0,
      },
      {
        grondsoortcategorieId: 4,
        omschrijving: "Aandeel zand, matig droog (VI)",
        grasland: 0,
        natuurgrasland: 0,
        akkerbouw: 0,
        snijmaisland: 0,
        graslandPercentage: 0,
        natuurgraslandPercentage: 0,
        akkerbouwPercentage: 0,
        snijmaislandPercentage: 0,
      },
      {
        grondsoortcategorieId: 5,
        omschrijving: "Aandeel zand, droog (VII-VIII)",
        grasland: 0.89,
        natuurgrasland: 0,
        akkerbouw: 0,
        snijmaisland: 0,
        graslandPercentage: 2,
        natuurgraslandPercentage: 0,
        akkerbouwPercentage: 0,
        snijmaislandPercentage: 0,
      },
      {
        grondsoortcategorieId: 6,
        omschrijving: "Onbekend",
        grasland: 0,
        natuurgrasland: 0,
        akkerbouw: 0,
        snijmaisland: 0,
        graslandPercentage: 0,
        natuurgraslandPercentage: 0,
        akkerbouwPercentage: 0,
        snijmaislandPercentage: 0,
      },
    ],
    kenmerkenOrganischeGronden: [
      {
        kenmerkOrganischeGrondCategorie: 1,
        graslandWaarde: 0,
        natuurgraslandWaarde: 0,
        snijmaisWaarde: 0,
        akkerbouwWaarde: 0,
        omschrijving: "Kust-vlakteveen",
      },
      {
        kenmerkOrganischeGrondCategorie: 2,
        graslandWaarde: 0,
        natuurgraslandWaarde: 0,
        snijmaisWaarde: 0,
        akkerbouwWaarde: 0,
        omschrijving: "Moerig in minerale gronden",
      },
    ],
  },
};

export type HerberekenModel = typeof MOCK_HERBEREKEN;
export const herberekenPerceelGegevens = (percelenHerberekenModel) =>
  klwAxios
    .post<HerberekenModel>("/percelen/herbereken", percelenHerberekenModel)
    .then((r) => r.data);

mock.onPost("/percelen/herbereken").reply(200, MOCK_HERBEREKEN);
